import React from 'react';
import { CoreDropdown } from '@komodo-design-system/komodo-components-react';
import './Filter.scss';

interface FilterOption {
  value: string;
  label: string;
}

interface FilterProps {
  onFilterChange?: (filters: { status: string; type: string }) => void;
  statusOptions?: FilterOption[];
  typeOptions?: FilterOption[];
  selectedStatus: string[];
  setSelectedStatus: any;
  selectedJob: string[];
  setSelectedJob: any;
  uniqueStatuseswithLabels?: { value: string; label: string }[];
  uniqueJobswithLabels?: { value: string; label: string }[];
  // handleAllDeselected?: (type: string) => void;
}

const Filter: React.FC<FilterProps> = ({
  selectedStatus,
  setSelectedStatus,
  selectedJob,
  setSelectedJob,
  uniqueStatuseswithLabels,
  uniqueJobswithLabels,
  // handleAllDeselected
}) => {

  const status1 = [{
    label:'In' , value: 'In'
  }];

  const handleJobChange = (event: any) => {
    const newStatus = event.detail.option?.value || '';
    const index = selectedJob.indexOf(newStatus);
    if (index === -1) {
      setSelectedJob([...selectedJob, newStatus]);
    } else {
      setSelectedJob(selectedJob.filter((status) => status !== newStatus));
    }
  };

  const handleStatusChange = (event: any) => {
    const newStatus = event.detail.option?.value || '';
    const index = selectedStatus.indexOf(newStatus);
    if (index === -1) {
      setSelectedStatus([...selectedStatus, newStatus]);
    } else {
      setSelectedStatus(selectedStatus.filter((status) => status !== newStatus));
    }
  };

  return (
    <div className="filter-container">
      <div className="filter-dropdowns">
        <div className="filter-item">
          <CoreDropdown
            wrap={true}
            style={{zIndex: '1 !important'}}
            data-testid="status-filter"
            placeholder="Select Job Name"
            functionality="multi-select"
            customkey="value"
            filterable
            menusize={4}
            counter={1}
            options={uniqueJobswithLabels || []}
            selected={selectedJob || []}
            onSelectionChanged={handleJobChange}
            clearalltext="Clear All"
            footer
            selectalllabel="Select All"
            selectalloption={Boolean(uniqueJobswithLabels?.length && uniqueJobswithLabels.length > 0)}
            onAllSelected={() => setSelectedJob(uniqueJobswithLabels?.map((job) => job.value) || [])}
            onAllDeselected={() => setSelectedJob([])}></CoreDropdown>
        </div>

        <div className="filter-item">
          <CoreDropdown
            showcaret
            style={{ zIndex: '1 !important' }}
            filterable
            data-testid="type-filter"
            placeholder="Select Status"
            functionality="multi-select"
            customkey="value"
            menusize={4}
            counter={1}
            options={uniqueStatuseswithLabels || []}
            selected={selectedStatus || []}
            onSelectionChanged={handleStatusChange}
            clearalltext="Clear All"
            footer
            selectalllabel="Select All"
            selectalloption={Boolean(uniqueJobswithLabels?.length && uniqueJobswithLabels.length > 0)}
            onAllSelected={() => setSelectedStatus(uniqueStatuseswithLabels?.map((status) => status.value) || [])}
            onAllDeselected={() => setSelectedStatus([])}></CoreDropdown>

        </div>
      </div>
    </div>
  );
};

export default Filter;
